// settings
// for production
export const MORAL_UP_NUM = 0.05;
export const COUNT_TO_ACTION = 2;
export const MIN_MORALE = 0.1;
export const SHOW_HP_BAR_NUM = false;

// for test
// export const MORAL_UP_NUM = 0;
// export const COUNT_TO_ACTION = 0;
// export const MIN_MORALE = 0.1;
// export const SHOW_HP_BAR_NUM = true;

export const PUBLIC_FIREBASE_PROJECT_ID = 'quiz-rpg';
export const PUBLIC_FIREBASE_API_KEY =
  'AIzaSyDEYkULvzs1Di5urPS9CoVPkdUkNABpdLY';

export const PHASE_QUIZ = 'PHASE_QUIZ';
export const PHASE_FRIEND_ATTACK = 'PHASE_FRIEND_ATTACK';
export const PHASE_WAIT_FRIEND_JUMP = 'PHASE_WAIT_FRIEND_JUMP';
export const PHASE_DAMAGE_ENEMY = 'PHASE_DAMAGE_ENEMY';
export const PHASE_CHECK_NEXT_FRIEND = 'PHASE_CHECK_NEXT_FRIEND';
export const PHASE_MINUS_ENEMY_COUNT = 'PHASE_MINUS_ENEMY_COUNT';
export const PHASE_ENEMY_ATTACK = 'PHASE_ENEMY_ATTACK';
export const PHASE_WAIT_ENEMY_JUMP = 'PHASE_WAIT_ENEMY_JUMP';
export const PHASE_DAMAGE_FRIEND = 'PHASE_DAMAGE_FRIEND';
export const PHASE_CHECK_NEXT_ENEMY = 'PHASE_CHECK_NEXT_ENEMY';
export const PHASE_WIN = 'PHASE_WIN';
export const PHASE_LOST = 'PHASE_LOST';
